import { getFirstSelectedInvoiceStreamId } from '@/shared/components/registration/registrationHelpers';
import { dynamicSort } from '@/shared/utils/dynamicSort';
import angular from 'angular';
import moment from 'moment';

angular
  .module('cloudX')
  .controller('InvoiceStreamSettingsDialogCtrl', [
    'resourceFactorySvc',
    'ModalService',
    'dataCache',
    'checkSecurity',
    '$translate',
    'translateListFilter',
    'flySvc',
    '$element',
    'close',
    'invoicestream',
    'relation',
    'forInvoicingVia',
    'invoiceStreamNamesSvc',
    invoiceStreamSettingsDialogCtrl,
  ]);

function invoiceStreamSettingsDialogCtrl(
  resourceFactorySvc,
  ModalService,
  dataCache,
  checkSecurity,
  $translate,
  translateListFilter,
  flySvc,
  $element,
  close,
  invoicestream,
  relation,
  forInvoicingVia,
  invoiceStreamNamesSvc,
) {
  const vm = this;
  vm.saving = false;
  vm.hasInvoiceTeamAccess = checkSecurity('InvoiceDraft:r') && relation.hasInvoiceTeamAccess;
  vm.readOnly = !checkSecurity('InvoiceDraft:u') || !relation.hasInvoiceTeamAccess;
  vm.invoicestream = angular.copy(invoicestream);
  if (!vm.invoicestream.startDate) {
    vm.invoicestream.startDate = moment
      .utc()
      .startOf('day')
      .toDate();
  }
  vm.isInvoicingVia = forInvoicingVia;
  vm.originalHasInvoicingVia = false;
  vm.schedule = null;
  vm.schedules = null;
  const lastYear = moment
    .utc()
    .startOf('day')
    .subtract(1, 'years');
  vm.datepickerOptions = {
    minDate: moment.utc(vm.invoicestream.startDate).isBefore(lastYear, 'day')
      ? vm.invoicestream.startDate
      : lastYear.toDate(),
    startingDay: 1,
  };
  vm.showValidation = false;

  const originalInvoicingType = vm.invoicestream.schedule
    ? vm.invoicestream.schedule.invoicingType
    : null;

  function showError(error) {
    flySvc.error(error.data.code, error.data.parameters);
    return '';
  }

  vm.loadSchedules = () =>
    resourceFactorySvc.get('invoiceSchedule').query(
      {},
      data => {
        vm.schedules = [
          {
            key: '0',
            label: $translate.instant('No invoice schedule'),
          },
          ...data
            .map(x => {
              const name = translateListFilter(x.id, 'invoiceSchedule', x.name);
              const invType = translateListFilter(x.invoicingType, 'invoicingType');
              return {
                ...x,
                key: `2;${x.id}`,
                label: `${name}          (${invType})`,
              };
            })
            .sort(dynamicSort('label')),
        ];

        if (invoicestream.invoicingViaRelation) {
          vm.schedule = null;
          vm.isInvoicingVia = true;
          vm.originalHasInvoicingVia = true;
        } else if (invoicestream.schedule) {
          vm.schedule = vm.schedules.find(x => x.key === `2;${invoicestream.schedule.id}`);
        } else {
          vm.schedule = vm.schedules.find(x => x.key === '0');
        }
      },
      showError,
    ).$promise;
  vm.loadSchedules();

  const updateInvoiceStream = model => {
    vm.saving = true;
    resourceFactorySvc
      .get('invoiceStream')
      .update(model)
      .$promise.then(
        response => {
          if (response) {
            flySvc.success('msgConfirmChange');
            if (vm.invoicestream.startDate > new Date())
              flySvc.message('msgInvoiceScheduleExistingLinesBeforeStartDateNotDeleted');
            close(response, 500);
            $element.modal('hide');
            vm.saving = false;
          }
          return false;
        },
        error => {
          showError(error);
          vm.saving = false;
        },
      );
  };

  vm.save = () => {
    if (vm.saving) return '';
    const model = angular.copy(vm.invoicestream);

    // Show warning message if previous invoicing type was advance/settlement and has now changed and if the schedule should start today
    if (originalInvoicingType === 2 && (!model.schedule || model.schedule.invoicingType !== 2)) {
      if (vm.hasUnsettledAdvances === null) return ''; // Still retrieving unsettled invoices
      if (vm.hasUnsettledAdvances) {
        return ModalService.showModal({
          template: require('./invoiceMethodChangedDialog.html'),
          controller: 'InvoiceMethodChangedDialogCtrl',
          controllerAs: 'vm',
          locationChangeSuccess: false,
          inputs: {
            advances: vm.hasUnsettledAdvances,
          },
        }).then(modal => {
          modal.element.modal();
          modal.element.on('hidden.bs.modal', e => {
            modal.element.off(e); // Remove event
            modal.element.remove(); // Remove element
          });
          modal.close.then(result => {
            if (result === null) return false;
            invoicestream.removeUnsettledAdvances = !!result;
            return updateInvoiceStream(model);
          });
        });
      }
    }

    return updateInvoiceStream(model);
  };

  vm.cancel = () => {
    close(null, 500);
  };

  vm.validateTemplate = () => {
    if (vm.isInvoicingVia) {
      if (!vm.invoicestream.invoicingViaRelation?.id) return false;
      if (!vm.invoicestream.invoicingViaStream?.id) return false;
    } else if (!vm.schedule) return false;

    const invoicingType = vm.invoicestream.schedule
      ? vm.invoicestream.schedule.invoicingType
      : null;
    if (invoicingType && (invoicingType == 1 || invoicingType == 2) && !vm.invoicestream.amount) {
      // vm.showValidation = true;
      return false;
    }
    if (!vm.invoicestream.startDate) {
      return false;
    }
    vm.showValidation = false;
    return true;
  };

  vm.hasUnsettledAdvances = null;
  vm.scheduleChanged = () => {
    let defaultLedger = '';

    if (!vm.schedule || vm.schedule.key === '0') {
      vm.invoicestream.schedule = null;
      vm.invoicestream.invoicingViaRelation = null;
      vm.invoicestream.invoicingViaStream = null;
    } else {
      vm.invoicestream.schedule = vm.schedule;
      vm.invoicestream.invoicingViaRelation = null;
      vm.invoicestream.invoicingViaStream = null;
    }

    if (vm.invoicestream.schedule) {
      const companyId = vm.invoicestream.companyId ?? relation.companyId;
      if (vm.invoicestream.schedule.invoicingType === 1) {
        defaultLedger = dataCache.getCompanySettings(companyId).fixedAmountLedgerAccount;
      }
      if (vm.invoicestream.schedule.invoicingType === 2) {
        defaultLedger = dataCache.getCompanySettings(companyId).advanceSettlementLedgerAccount;
      }
    }
    vm.invoicestream.ledgerAccount = defaultLedger;
    vm.datepickerOptions.minDate = lastYear.toDate();
    vm.invoicestream.startDate = null;

    // Retrieve unsettled advances if old schedule was advance/settlement
    if (
      vm.hasUnsettledAdvances === null &&
      originalInvoicingType === 2 &&
      (!vm.invoicestream.schedule || vm.invoicestream.schedule.invoicingType !== 2)
    ) {
      resourceFactorySvc.get('invoiceStream').unsettledAdvances(
        { id: vm.invoicestream.id },
        ({ amount = 0, invoiceIds = [] }) => {
          if (invoiceIds.length) {
            vm.hasUnsettledAdvances = { amount, invoiceIds, count: invoiceIds.length };
          } else {
            vm.hasUnsettledAdvances = false;
          }
        },
        showError,
      );
    }
  };

  const loadInvoicingViaStreams = (invoicingViaRelation, selectDefault) => {
    return invoiceStreamNamesSvc.get(invoicingViaRelation.id).then(streams => {
      //Ignore stale responses when the invoicing-via relation changed in the meantime
      if (vm.invoicestream.invoicingViaRelation !== invoicingViaRelation) return;
      if (selectDefault && (!streams || !streams.length)) {
        //Relation without invoice streams cannot be invoiced via
        flySvc.warning('msgCannotSelectRelationWithoutInvoiceStreams');
        vm.invoicestream.invoicingViaRelation = null;
        vm.invoicestream.invoicingViaStream = null;
        vm.invoicingViaStreams = null;
        return;
      }
      vm.invoicingViaStreams = streams || [];
      if (selectDefault) {
        const id =
          vm.invoicestream.invoicingViaStream?.id ??
          getFirstSelectedInvoiceStreamId(
            vm.invoicingViaStreams,
            invoicingViaRelation.invoiceStreamId,
          );
        vm.invoicestream.invoicingViaStream = vm.invoicingViaStreams.find(x => x.id === id);
      } else if (vm.invoicestream.invoicingViaStream?.id) {
        //Replace the reference with the full stream from the list so the picker can match it
        vm.invoicestream.invoicingViaStream =
          vm.invoicingViaStreams.find(x => x.id === vm.invoicestream.invoicingViaStream.id) ||
          vm.invoicestream.invoicingViaStream;
      }
    });
  };

  vm.invoicingViaStreams = null;
  if (vm.invoicestream.invoicingViaRelation?.id) {
    loadInvoicingViaStreams(vm.invoicestream.invoicingViaRelation, false);
  }

  vm.invoicingViaRelationChanged = () => {
    vm.invoicingViaStreams = null;
    if (!vm.invoicestream.invoicingViaRelation) {
      vm.invoicestream.invoicingViaStream = null;
      return;
    }
    if (!vm.invoicestream.invoicingViaRelation.id) return;
    loadInvoicingViaStreams(vm.invoicestream.invoicingViaRelation, true);
  };

  vm.clearInvoicingVia = () => {
    vm.invoicestream.schedule = null;
    vm.invoicestream.invoicingViaRelation = null;
    vm.invoicestream.invoicingViaStream = null;
    vm.save();
  };
}
